var styles = {"keyFigure":"styles_key-figure__qGBGh","value":"styles_value__GfZjG","small":"styles_small__LQXro","description":"styles_description__Za7Yi","noSpacing":"styles_no-spacing__xpQDH","compactSpacing":"styles_compact-spacing__8qOBd","comfortableSpacing":"styles_comfortable-spacing__NZxhc","looseSpacing":"styles_loose-spacing__t-tE1"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
